import { Box, Stack, Button } from '@mui/material';
import { useContext, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import PageHeader from '../../components/PageHeader';
import { Context as AppContext } from '../../context/AppContext';
import { MainLayout } from '../../layouts/main-layout/MainLayout';
import AiChat from '../ai-designer/AiChat';

const ClassGptChat = () => {
    const { state: { GPTS }, updateGPT, deleteGPT } = useContext(AppContext)
    const { uid } = useParams();
    const [gpt, setGpt] = useState(null)
    const navigate = useNavigate();

    useEffect(() => {
        const gpt = GPTS.find(gpt => gpt.uid === uid)
        if (gpt) {
            setGpt(gpt)
        } else {
            navigate('/class-gpt')
        }
    }, [uid, GPTS, navigate])

    if (!gpt) {
        return <div>Loading...</div>
    }

    return (
        <MainLayout>
            <Box sx={{
                p: 3,
                position: 'relative',
                display: 'flex',
                flexDirection: "column",
                height: '80vh'
            }}>
                <Stack
                    direction={{ xs: 'row' }}
                    alignItems={{ xs: 'flex-start', sm: 'flex-start' }}
                    justifyContent={{ xs: 'flex-start', sm: 'space-between' }}
                    spacing={2}
                    sx={{ mb: 2, flexShrink: 0 }}
                >
                    <PageHeader
                        title={`In-Class GPT - `}
                        rainbowText={gpt?.title}
                    />
                </Stack>

                <Box sx={{ 
                    flexGrow: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    height: 'calc(100vh - 180px)', // Adjust based on your header height
                    overflow: 'hidden'
                }}>
                    <AiChat
                        initialMessages={gpt?.messages}
                        showSelectors={false}
                        gptUid={gpt?.uid}
                    />
                </Box>
            </Box>
        </MainLayout>
    );
};

export default ClassGptChat; 